import Controller from './Controller';
import type Report from '../checks/Report';
import { CEMC_Event } from '../commands/metamodel/complex';
import { Combined_DeleteEvent } from '../commands/combined';
import type { OrId, EventUpdates } from '../commands/types';
import type { IEventType } from '../../stores/model/metamodel/event_type';

/**
 * Edit or delete an event type.
 */
export default class EditEventController extends Controller {
  async editEvent(
    id: OrId<IEventType>,
    updates: EventUpdates,
    propagateRename: boolean
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_Event(model, id, updates, propagateRename);
      return checks;
    });
  }

  async deleteEvent(id: OrId<IEventType>): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteEvent(model, id);
      return checks;
    });
  }
}
